import {AxiosInstance} from "axios";
import {FeatureHighlight} from "@/core/interfaces/feature-highlight/FeatureHighlight";
import {PaginatedData} from "@/core/interfaces/api";

export default function (apiClient: AxiosInstance) {
    return {
        /**
         * Get feature highlights.
         */
        async index(
            active?: boolean,
            paginationParams?: {
                limit?: number,
                page?: number
            }
        ): Promise<PaginatedData<FeatureHighlight[]>> {
            return apiClient.get('feature-highlights', {
                params: {
                    current: active,
                    ...paginationParams
                }
            })
                .then(response => response.data);
        },

        /**
         * Toggle feature highlight for a health center.
         */
        async toggle(featureHighlightId: number): Promise<void> {
            return apiClient.post(`feature-highlights/${featureHighlightId}/toggle`)
                .then(response => response.data);
        }
    };
}
